import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Search } from 'lucide-react';
import RecipeCard from '../components/RecipeCard';
import { recipes, recipeTypes } from '../data/recipes';

const RecipesPage = () => {
  const [selectedType, setSelectedType] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  // Filter recipes
  const filteredRecipes = recipes.filter(recipe => {
    const matchesType = selectedType === 'All' || recipe.type === selectedType;
    const matchesSearch = recipe.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesType && matchesSearch;
  });

  return (
    <div className="space-y-8">
      {/* Back Button */}
      <Link
        to="/integrative-health"
        className="inline-flex items-center text-slate-600 hover:text-slate-900 transition-colors"
      >
        <ArrowLeft className="h-5 w-5 mr-2" />
        Back to Integrative Health
      </Link>

      {/* Header */}
      <div>
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900 mb-4">
          Recipes (Supportive)
        </h1>
        <p className="text-lg text-slate-700 leading-relaxed mb-6">
          Simple, whole-food recipes often chosen by people seeking plant-forward, anti-inflammatory eating patterns.
        </p>
      </div>

      {/* Global Disclaimer */}
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-6">
        <p className="text-sm text-slate-700 leading-relaxed">
          This information is provided for educational purposes only and does not replace professional medical advice. Always consult your healthcare provider before making dietary, supplement, or lifestyle changes, especially if you are immunocompromised, have low blood counts, or are undergoing treatment.
        </p>
      </div>

      {/* Recipe Library */}
      <div className="bg-white rounded-2xl p-6 md:p-8 border border-slate-100">
        <h2 className="text-2xl font-bold text-slate-900 mb-6">
          Recipe Library
        </h2>

        {/* Filters */}
        <div className="space-y-4 mb-6">
          {/* Search */}
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-slate-400" />
            <input
              type="text"
              placeholder="Search recipes..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-3 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* Type Filter */}
          <div className="flex gap-2 overflow-x-auto pb-2">
            <button
              onClick={() => setSelectedType('All')}
              className={`px-4 py-2 rounded-lg font-medium whitespace-nowrap transition-colors ${
                selectedType === 'All'
                  ? 'bg-blue-600 text-white'
                  : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
              }`}
            >
              All Recipes
            </button>
            {recipeTypes.map((type) => (
              <button
                key={type}
                onClick={() => setSelectedType(type)}
                className={`px-4 py-2 rounded-lg font-medium whitespace-nowrap transition-colors ${
                  selectedType === type
                    ? 'bg-blue-600 text-white'
                    : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                }`}
              >
                {type}
              </button>
            ))}
          </div>
        </div>

        {/* Results Count */}
        <p className="text-sm text-slate-600 mb-4">
          Showing {filteredRecipes.length} {filteredRecipes.length === 1 ? 'recipe' : 'recipes'}
        </p>

        {/* Recipe Cards */}
        <div className="space-y-4">
          {filteredRecipes.length > 0 ? (
            filteredRecipes.map((recipe) => (
              <RecipeCard key={recipe.id} recipe={recipe} />
            ))
          ) : (
            <div className="text-center py-12">
              <p className="text-slate-600">No recipes match your search.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecipesPage;